import Vue from 'vue';
import Vuex from 'vuex';
import user from '@/store/modules/user';
import useModalStore from '@/store/modules/useModalStore';
import membership from '@/store/modules/membership';
import websocket from '@/store/modules/websocket';
import createLogger from '@/store/plugins/logger';
import agentSettings from '@/store/modules/agentSettings';
import agentProfiles from '@/store/modules/agentProfiles';
import activeFilters from './modules/activeFilters';
import abandonedCheckout from './modules/abandonedCheckout';
import tours from './modules/tours';
import tags from './modules/tags';
import accountMembers from './modules/accountMembers';
import blacklist from './modules/blacklist';
import onboardingTodos from '@/store/modules/onboardingTodos';
import dashboard from './modules/dashboard';
import thanksOrder from './modules/thanksOrder';
import reviewRequest from './modules/reviewRequest'; // Modified by Antigravity - 2026-05-25
import postPurchase from './modules/postPurchase';
import chatFolders from './modules/chatFolders';
import startConversation from './modules/startConversation';
import announcements from './modules/announcements';
import shippingUpdate from './modules/shippingUpdate';
import pipeline from './modules/pipeline';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

// Custom action filter to exclude 'user/apiCall'
const customActionFilter = (action) => {
    return action.type !== 'user/apiCall';
};

export default new Vuex.Store({
    modules: {
        user,
        modalStore: useModalStore,
        membership,
        websocket,
        agentSettings,
        agentProfiles,
        activeFilters,
        abandonedCheckout,
        tours,
        tags,
        accountMembers,
        blacklist,
        onboardingTodos,
        dashboard,
        chatFolders,
        thanksOrder,
        reviewRequest, // Modified by Antigravity - 2026-05-25
        postPurchase,
        startConversation,
        announcements,
        shippingUpdate,
        pipeline,
    },
    strict: debug,
    plugins: debug
        ? [
              createLogger({
                  actionFilter: customActionFilter,
              }),
          ]
        : [],
});
